"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilterCommunicationKey;
(function (FilterCommunicationKey) {
    FilterCommunicationKey["ON_FILTER_SELECT"] = "on_filter_select";
    FilterCommunicationKey["ON_FILTER_UNSELECT"] = "on_filter_unselect";
})(FilterCommunicationKey = exports.FilterCommunicationKey || (exports.FilterCommunicationKey = {}));
//# sourceMappingURL=filter-communication-key.js.map